/*****/ document.addEventListener("DOMContentLoaded", function () {
    function formatPrices() {
        document.querySelectorAll("#_rsi-cod-form-modal .money").forEach(function (el) {
            let priceText = el.innerText.replace(/[^\d]/g, ""); 
            if (priceText) {
                let formattedPrice = Number(priceText).toLocaleString("en-US").replace(/,/g, ".");
                el.innerText = formattedPrice.replace(/\./g, ",");
            }
        });
    }

    // Check if modal is open every second and format prices
    setInterval(function () {
        let modal = document.querySelector("#_rsi-cod-form-modal");
        if (modal && modal.style.display !== "none") {
            formatPrices();
        }
    }, 1000); // Runs every second
});


/*****/

/*********Bucks Space in Ksh******
document.addEventListener('DOMContentLoaded', function() {
    // Function to format the money display
    function formatMoneyDisplay() {
        document.querySelectorAll('.buckscc-money').forEach(element => {
            const text = element.textContent;
            if (text.includes('KSh') && !text.includes('KSh ')) {
                // Remove existing formatting and add space
                const amount = text.replace('KSh', '').trim();
                element.textContent = `KSh ${amount}`;
            }
        });
    }

    // Run immediately in case elements are already there
    formatMoneyDisplay();

    // Set up MutationObserver to watch for dynamic changes
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes) {
                formatMoneyDisplay();
            }
        });
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Optional: Also observe attribute changes in case the amount updates without node replacement
    const moneyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'characterData' || mutation.attributeName === 'class') {
                formatMoneyDisplay();
            }
        });
    });

    // Observe existing money elements
    document.querySelectorAll('.buckscc-money').forEach(el => {
        moneyObserver.observe(el, {
            characterData: true,
            attributes: true,
            subtree: true
        });
    });
});              ****/


document.addEventListener('DOMContentLoaded', () => {
    const menu = document.getElementById('Details-menu-drawer-container');
    const button = document.querySelector('#_rsi-buy-now-button-floating');
    
    if (menu && button) {
        // Store the original display value (defaults to computed style if not set)
        const originalDisplay = window.getComputedStyle(button).display;
        
        new MutationObserver((mutations) => {
            if (menu.classList.contains('menu-opening')) {
                // Hide the button if menu is opening
                button.style.display = 'none';
            } else {
                // Restore the original display value when menu closes
                button.style.display = originalDisplay;
            }
        }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    }
});


/***

///Tidio Contact Us Button
document.addEventListener('DOMContentLoaded', function() {
  // First check if Tidio iframe exists
  const checkForTidio = setInterval(function() {
    const iframe = document.querySelector('#tidio-chat-iframe');
    const chatTrigger = document.getElementById('HeaderDrawer-contact-us');
    
    if (iframe) {
      clearInterval(checkForTidio); // Stop checking once found
      
      // Show the contact us button
      if (chatTrigger) {
        chatTrigger.style.display = 'block'; // or 'inline' or '' depending on your layout
        
        // Add click handler
        chatTrigger.addEventListener('click', function(e) {
          e.preventDefault();
          // Try Tidio's official method first
          if (typeof tidioChatApi !== 'undefined') {
            tidioChatApi.open();
          } 
          // Fallback to iframe click
          else {
            iframe.click();
          }
        });
      }
    } else {
      // Hide the contact us button if iframe not found
      if (chatTrigger) {
        chatTrigger.style.display = 'none';
      }
    }
  }, 500); // Check every 500ms

  // Optional: Add timeout to stop checking after a while
  setTimeout(function() {
    clearInterval(checkForTidio);
  }, 10000); // Stop checking after 10 seconds
});

****/




//Last week Sales


document.addEventListener('DOMContentLoaded', function() {
  // Get the product metafield value (assuming it's available in the global theme object)
  const productData = window.productData || {};
  const lastWeekSales = productData.metafields?.custom?.last_week_sales?.value;
  
  // Get the product form buttons element
  const productFormButtons = document.querySelector('.product-form__buttons');
  
  if (lastWeekSales && productFormButtons) {
    // Create the message element
    const salesMessage = document.createElement('div');
    salesMessage.className = 'last-week-sales-message';
    salesMessage.textContent = `Over ${lastWeekSales} sold in the last week`;
    salesMessage.style.marginBottom = '10px';
    salesMessage.style.textAlign = 'center';
    salesMessage.style.fontSize = '0.9em';
    salesMessage.style.color = '#555';
    
    // Insert the message before the product form buttons
    productFormButtons.parentNode.insertBefore(salesMessage, productFormButtons);
  }
});

